import { useEffect } from "react";

function upsertMeta(name, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// Manage per-page <title>, meta description and robots (index/noindex).
export function useSeo({ title, description, noindex = false } = {}) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;
    if (description) upsertMeta("description", description);
    upsertMeta("robots", noindex ? "noindex,nofollow" : "index,follow");
    return () => {
      document.title = prevTitle;
      upsertMeta("robots", "index,follow");
    };
  }, [title, description, noindex]);
}
